import React from 'react';
import { X, CheckCheck, Bell, Info, AlertTriangle, ShieldAlert } from 'lucide-react';
import { useNotifications } from '../../context/NotificationContext.js';
import { Badge } from '../ui/Badge.js';
import './notifications.css';

export const NotificationDrawer: React.FC = () => {
  const { isDrawerOpen, closeDrawer, notifications, unreadCount, markAsRead, markAllAsRead } = useNotifications();

  if (!isDrawerOpen) return null;

  const getPriorityVariant = (priority: string) => {
    switch (priority) {
      case 'URGENT': return 'danger';
      case 'HIGH': return 'warning';
      case 'MEDIUM': return 'info';
      default: return 'neutral';
    }
  };

  const getCategoryIcon = (priority: string) => {
    switch (priority) {
      case 'URGENT': return ShieldAlert;
      case 'HIGH': return AlertTriangle;
      default: return Info;
    }
  };

  return (
    <div className="notification-backdrop" onClick={closeDrawer}>
      <div className="notification-panel" onClick={(e) => e.stopPropagation()}>
        <div className="notification-header">
          <div className="notification-title-box">
            <Bell size={18} className="notification-icon" />
            <h3 className="notification-title">System Notifications</h3>
            {unreadCount > 0 && <span className="unread-counter-badge">{unreadCount} New</span>}
          </div>
          <div className="notification-actions">
            {unreadCount > 0 && (
              <button className="mark-all-btn" onClick={markAllAsRead} title="Mark all as read">
                <CheckCheck size={16} />
                <span>Mark All Read</span>
              </button>
            )}
            <button className="close-drawer-btn" onClick={closeDrawer}>
              <X size={18} />
            </button>
          </div>
        </div>

        <div className="notification-list">
          {notifications.length === 0 ? (
            <div className="empty-notifications">
              <Bell size={32} className="empty-bell-icon" />
              <p>No notifications yet</p>
              <span>You are all caught up!</span>
            </div>
          ) : (
            notifications.map((item) => {
              const Icon = getCategoryIcon(item.priority);
              return (
                <div
                  key={item.id}
                  className={`notification-card ${!item.isRead ? 'unread' : ''}`}
                  onClick={() => !item.isRead && markAsRead(item.id)}
                >
                  <div className="notification-card-header">
                    <div className="priority-icon-box">
                      <Icon size={16} />
                    </div>
                    <span className="notification-card-title">{item.title}</span>
                    <Badge variant={getPriorityVariant(item.priority)}>{item.priority}</Badge>
                  </div>
                  <p className="notification-card-msg">{item.message}</p>
                  <div className="notification-card-footer">
                    <span className="notification-time">
                      {new Date(item.createdAt).toLocaleString()}
                    </span>
                    {!item.isRead && <span className="unread-dot" />}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};
